import React, { useEffect } from 'react';
import { Container, Box, Typography, Button, Paper } from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { googleLogin } from '../services/api';

const Login = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const userData = params.get('user');

    if (token && userData) {
      try {
        const parsedUser = JSON.parse(decodeURIComponent(userData));
        login(parsedUser, token);
        navigate('/dashboard');
      } catch (error) {
        console.error('Failed to parse user data', error);
      }
    } else if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate, location, login]);

  const handleGoogleLogin = () => {
    googleLogin();
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Typography component="h1" variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            StackTrack
          </Typography>
          
          <Typography component="h2" variant="h6" color="textSecondary" gutterBottom>
            Sign in to continue
          </Typography>

          <Box sx={{ mt: 4, width: '100%' }}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<GoogleIcon />}
              onClick={handleGoogleLogin}
              sx={{ 
                mt: 1, 
                mb: 2,
                py: 1.5,
                textTransform: 'none',
                fontSize: '1rem'
              }}
            >
              Login with Google
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
